import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, PaperClip, Textarea, Select, DatePicker } from 'components';
import { OperatorService, ClientQuoteService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import moment from 'moment';
import { connect } from 'react-redux';
import { QuoteService } from 'services';

interface Props extends RootState {
	onClose?: any;
	item?: any;
	updateTitleModal?: any;
}

const INITIAL_STATE = {
	observations: '',
	payment_method_id: '',
	payment_email: '',
	payment_phone: '',
	payment_date: '',
	payment_bank_id: '',
	payment_reference: '',
	payment_photo: '',
	payment_bank_account_id: '',
	payment_name: '',
}

declare var window: any;

class ModalChangeStatusPayment extends React.Component<Props> {

	state = {
		item: this.props.item,
		form: INITIAL_STATE,
		visible_edit: false,
		payment_methods: [],
		banks: [],
		bank_accounts: [],
		all_quotes: [],
		isLightboxOpen: false, // Nuevo estado para controlar el modal
	}

	async componentDidMount() {
		if (this.state.item?.observations) {
			await this.setState({
				form: {
					...this.state.form,
					observations: this.state.item?.observations
				}
			});
		}

		this.setState({
			form: {
				...this.state.form,
				payment_method_id: this.state.item?.payment_method_id || '',
				payment_email: this.state.item?.payment_email || '',
				payment_phone: this.state.item?.payment_phone || '',
				payment_date: this.state.item?.payment_date ? moment(this.state.item?.payment_date).toDate() : '',
				payment_bank_id: this.state.item?.bank_id || '',
				payment_reference: this.state.item?.payment_reference || '',
				payment_bank_account_id: this.state.item?.payment_bank_account_id || '',
				payment_name: this.state.item?.payment_name || ''
			}
		});

		this.loadData();
		this.load();
	}

	loadData = async () => {
		const res: any = await ClientQuoteService.client.getBanks({
			withoutLoading: true
		});
		this.setState({
			banks: res.banks,
			payment_methods: res.payment_methods.filter((i: any) => [Constants.PAYMENT_METHODS.CORPORATE,Constants.PAYMENT_METHODS.STRIPE].indexOf(i.id) == -1),
			bank_accounts: res.bank_accounts
		});
	}

	load = async () => {
		const res: any = await QuoteService.admin.getQuotePayment({
			quote_id: this.props.item?.id
		});
		this.setState({
			all_quotes: res.all_quotes
		});
	}
	
	accept = () => {
		Globals.confirm('¿Desea aceptar el pago? Esta acción no se puede deshacer',async () => {
			await QuoteService.admin.accept({
				quote_id: this.state.item?.id,
				...this.state.form
			});
			this.props.onClose(true);
			Globals.showSuccess("Se ha aceptado el pago");
		});
	}

	reject = async () => {
		Globals.confirm('¿Desea rechazar el pago? Esta acción no se puede deshacer',async () => {
			await QuoteService.admin.reject({
				quote_id: this.state.item?.id,
				...this.state.form
			});
			this.props.onClose(true);
			Globals.showSuccess("Se ha rechazado el pago");
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	viewURL = (e: any, url: string) => {
		if (window.webkit && window.webkit.messageHandlers) {
			e.preventDefault();
			const message = 'open_url';
			const sendToNative = {
				message,
				url
			}
			const stringifiedMessageObj = JSON.stringify(sendToNative);
	        window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
	    }
	}

	downloadPaymentPhoto = async (e: any, url: string) => {
		// 1. Evitamos comportamientos por defecto y propagación (para que no cierre el modal)
		e.preventDefault();
		e.stopPropagation();

		try {

			// 3. Hacemos un fetch a la URL de la imagen
			const response = await fetch(url, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/octet-stream',
				},
			});

			if (!response.ok) throw new Error('Error de red al descargar imagen');

			// 4. Convertimos la respuesta en un BLOB
			const blob = await response.blob();

			// 5. Creamos una URL temporal en memoria para ese blob
			const blobUrl = window.URL.createObjectURL(blob);

			// 6. Creamos un elemento <a> invisible en el DOM
			const link = document.createElement('a');
			link.href = blobUrl;

			// 7. Asignamos nombre al archivo (puedes dinamizarlo con el ID del item si quieres)
			link.download = `comprobante_pago_${new Date().getTime()}.jpg`;

			document.body.appendChild(link);

			// 8. Forzamos el clic y limpiamos
			link.click();

			document.body.removeChild(link);
			window.URL.revokeObjectURL(blobUrl);

		} catch (error) {
			console.error("Error en la descarga directa:", error);

			// Fallback (Plan B): Si falla el método Blob (por CORS estricto), 
			// intentamos abrirla en nueva pestaña a la vieja usanza.
			window.open(url, '_blank');
		}
	}

	editPaymentData = () => {
		this.setState({
			visible_edit: true
		});
	}

	submitPayment = async () => {
		if (this.state.form.payment_method_id == Constants.PAYMENT_METHODS.CASH2.toString()) {
			if (!this.state.form.payment_photo) {
				Globals.showError("Debe ingresar la foto de los billetes");
				return;
			}
		}
		else if (this.state.form.payment_method_id == Constants.PAYMENT_METHODS.MOVIL.toString()) {
			if (!this.state.form.payment_date) {
				Globals.showError("Debe ingresar la fecha del pago");
				return;
			}

			if (!this.state.form.payment_phone) {
				Globals.showError("Debe ingresar el teléfono del pago móvil");
				return;
			}

			if (!this.state.form.payment_bank_id) {
				Globals.showError("Debe ingresar el banco del pago móvil");
				return;
			}

			if (!this.state.form.payment_reference) {
				Globals.showError("Debe ingresar el número de referencia");
				return;
			}
		}
		else if (this.state.form.payment_method_id == Constants.PAYMENT_METHODS.TRANSFER.toString()) {
			if (!this.state.form.payment_date) {
				Globals.showError("Debe ingresar la fecha del pago");
				return;
			}

			if (!this.state.form.payment_bank_id) {
				Globals.showError("Debe ingresar el banco de la transferencia");
				return;
			}

			if (!this.state.form.payment_reference) {
				Globals.showError("Debe ingresar el número de referencia");
				return;
			}

			if (!this.state.form.payment_photo) {
				Globals.showError("Debe ingresar la foto del pago");
				return;
			}
		}
		else if (this.state.form.payment_method_id == Constants.PAYMENT_METHODS.ZELLE.toString()) {
			if (!this.state.form.payment_name) {
				Globals.showError("Persona que realizó el pago");
				return;
			}

			if (!this.state.form.payment_date) {
				Globals.showError("Debe ingresar la fecha de pago");
				return;
			}
		}
		else if (this.state.form.payment_method_id == Constants.PAYMENT_METHODS.CASH.toString()) {
			if (!this.state.form.payment_bank_account_id) {
				Globals.showError("Debe ingresar la cuenta bancaria");
				return;
			}

			if (!this.state.form.payment_date) {
				Globals.showError("Debe ingresar la fecha del pago");
				return;
			}

			if (!this.state.form.payment_reference) {
				Globals.showError("Debe ingresar el número de referencia");
				return;
			}
		}

		const res: any = await QuoteService.admin.changePayment({
			quote_id: this.state.item?.id,
			...this.state.form,
			hasFile: true,
			// @ts-ignore,
			payment_photo: this.state.form.payment_photo?.value || '',
			payment_date: this.state.form.payment_date && moment(this.state.form.payment_date).format('YYYY-MM-DD'),
		});
		Globals.showSuccess("Se han actualizado los datos de pago");
		this.setState({
			visible_edit: false,
			item: res.quote || this.state.item,
			form: {
				...this.state.form,
				payment_method_id: res.quote?.payment_method_id || '',
				payment_email: res.quote?.payment_email || '',
				payment_phone: res.quote?.payment_phone || '',
				payment_date: res.quote?.payment_date ? moment(res.quote?.payment_date).toDate() : '',
				payment_bank_id: res.quote?.bank_id || '',
				payment_reference: res.quote?.payment_reference || '',
				payment_bank_account_id: res.quote?.payment_bank_account_id || '',
				payment_photo: '',
				payment_name: res.quote?.payment_name || ''
			}
		});
		const payment_method: any = this.state.payment_methods.find((item: any) => res.quote?.payment_method_id == item.id);
		this.props.updateTitleModal(payment_method?.name);
	}

	toggleLightbox = (isOpen: boolean) => {
		this.setState({ isLightboxOpen: isOpen });
	}

	render() {
		const all_quotes: any = this.state.all_quotes;
		const payment_movil: any = this.state.payment_methods.find((i: any) => i.id == Constants.PAYMENT_METHODS.MOVIL);
		const bank_account: any = this.state.bank_accounts.find((i: any) => i.id == this.state.form.payment_bank_account_id);
		const transfer: any = this.state.payment_methods.find((i: any) => i.id == Constants.PAYMENT_METHODS.TRANSFER);
		const payment_zelle: any = this.state.payment_methods.find((i: any) => i.id == Constants.PAYMENT_METHODS.ZELLE);
		const payment_pending = [Constants.QUOTE_STATUS.PENDING,Constants.QUOTE_STATUS.ASSIGNED,Constants.QUOTE_STATUS.IN_PROGRESS].indexOf(this.state.item?.status) != -1 && this.state.item?.status_payment == Constants.QUOTE_PAYMENT_STATUS.PENDING;
		const price = all_quotes?.length > 0 ? all_quotes?.map((i: any) => i.price).reduce((a: number, b:number) => a + b,0) : this.state.item?.price;

		const imageUrl = this.state.item?.payment_photo
			? Constants.BASE_STORAGE + this.state.item.payment_photo
			: null;

		return (
			<div id="modal-change-status-payment">
				<div className="row">
					<div className="col-md-6">
						<p className="total">{ Globals.formatMiles(price) }</p>
						<p className="total-bs">{ Globals.formatMiles(price,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,this.state.item?.conversion?.amount || 0) }</p>
					</div>
					<div className="col-md-6">
						<h3 className="title-dates">Servicios: { this.state.all_quotes.length || 1 }</h3>
						<h3 className="title-dates">Fechas del servicio:</h3>
						{
							(this.state.all_quotes.length > 0 ? this.state.all_quotes : [this.state.item]).map((item: any) => {
								return (
									<p className="dates-multiple">{ moment(item.date).format('DD/MM/YYYY') }</p>
								)
							})
						}
					</div>
				</div>
				
				{
					!this.state.visible_edit && (
						<React.Fragment>
							{ this.state.item?.payment_bank != null && <p><strong>Banco:</strong> { this.state.item?.payment_bank?.name }</p> }
							{ this.state.item?.bank_account != null && <p><strong>Cuenta bancaria:</strong> { this.state.item?.bank_account?.number } { this.state.item?.bank_account?.bank?.name }</p> }
							{ (this.state.item?.payment_phone != null || this.state.item?.bfc_payment_data?.NROTLF) != null && <p><strong>Teléfono:</strong> { this.state.item?.payment_phone || this.state.item?.bfc_payment_data?.NROTLF }</p> }
							{ this.state.item?.payment_email != null && <p><strong>Correo:</strong> { this.state.item?.payment_email }</p> }
							{ this.state.item?.payment_date != null && <p><strong>Fecha:</strong> { moment(this.state.item?.payment_date).format('DD/MM/YYYY') }</p> }
							{ (this.state.item?.bfc_payment_data?.FECHA != null && this.state.item?.bfc_payment_data?.HORAR != null) && <p><strong>Fecha:</strong> { this.state.item?.bfc_payment_data?.FECHA } { this.state.item?.bfc_payment_data?.HORAR }</p> }
							{ (this.state.item?.bfc_payment_data?.TIPDOC != null && this.state.item?.bfc_payment_data?.NUMDOC != null) && <p><strong>Documento:</strong> { this.state.item?.bfc_payment_data?.TIPDOC }{ this.state.item?.bfc_payment_data?.NUMDOC }</p> }
							{ (this.state.item?.payment_reference != null || this.state.item?.bfc_payment_data?.NROREFERENCIA != null) && <p><strong>Referencia:</strong> { this.state.item?.payment_reference || this.state.item?.bfc_payment_data?.NROREFERENCIA }</p> }
							{ (this.state.item?.payment_name != null) && <p><strong>Persona que realizó el pago:</strong> { this.state.item?.payment_name }</p> }

							{/* {
								this.state.item?.payment_photo && (
									<div className="text-center">
										<a onClick={ (e: any) => this.viewURL(e,Constants.BASE_STORAGE + this.state.item?.payment_photo) } href={ Constants.BASE_STORAGE + this.state.item?.payment_photo } target="_blank">
											<button className="btn btn-image">
												Ver imagen del pago
											</button>
										</a>
									</div>
								)
							} */}

							{/* 1. LA MINIATURA (Reemplaza al botón anterior) */}
							{imageUrl && (
								<div className="text-center mt-3 mb-3">
									<p><strong>Comprobante de pago:</strong></p>
									<img
										src={imageUrl}
										alt="Comprobante de pago"
										className="payment-thumbnail"
										onClick={() => this.toggleLightbox(true)}
									/>
								</div>
							)}

							{/* 2. EL MODAL (LIGHTBOX) */}
							{this.state.isLightboxOpen && imageUrl && (
								<div className="lightbox-overlay" onClick={() => this.toggleLightbox(false)}>
									{/* 
										Al hacer click en el overlay, cerramos. 
                        				StopPropagation en la imagen evita que se cierre al tocar la imagen misma 
									*/}
									<img
										src={imageUrl}
										className="lightbox-image"
										alt="Comprobante ampliado"
										onClick={(e) => e.stopPropagation()}
									/>

									<div className="lightbox-controls" onClick={(e) => e.stopPropagation()}>
										<button
											className="btn btn-primary"
											onClick={(e) => this.downloadPaymentPhoto(e, imageUrl)}
											style={{ cursor: 'pointer' }}
										>
											<i className="fa fa-download"></i> Descargar
										</button>

										<button
											className="btn btn-secondary"
											onClick={() => this.toggleLightbox(false)}
										>
											Cerrar
										</button>
									</div>
								</div>
							)}

							{
								payment_pending && this.state.item?.origin == Constants.QUOTES_ORIGIN.ADMIN && (
									<Button type="button" onClick={ () => this.editPaymentData() } className="btn-edit">
										Editar Datos de Pago
									</Button>
								)
							}
						</React.Fragment>
					)
				}

				{
					this.state.visible_edit && (
						<div className="form-payment">
							<Select
								label="Forma de Pago"
								name="payment_method_id"
								onChange={ (e: any) => {
									this.setState({
										form: {
											...INITIAL_STATE,
											payment_method_id: e.target.value
										}
									});
								} }
								value={ this.state.form.payment_method_id }
								options={ this.state.payment_methods.map((item: any) => {
									return {
										value: item.id,
										label: item.name
									}
								}) } />

							{
								// @ts-ignore
								this.state.form.payment_method_id == Constants.PAYMENT_METHODS.MOVIL && (
									<React.Fragment>			
										<div className="row row-payments">
											<div className="col-md-8">
												<h6>Datos para el pago</h6>
												<p>{ payment_movil?.bank?.name } - { payment_movil?.bank?.code }</p>
												<p>{ payment_movil?.document_type?.name + payment_movil?.document }</p>
												<p>{ payment_movil?.phone }</p>
											</div>
											<div className="col-md-4 text-right">
												<h6>Total a pagar</h6>
												<p className="total">{ Globals.formatMiles(this.state.item?.price) }</p>
												<p className="total-bs">{ Globals.formatMiles(this.state.item?.price,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,this.props.conversion?.amount || 0) }</p>
											</div>
										</div>						
										<div className="row">
											<div className="col-12">
												<h5>Confirmar pago</h5>
												<Select
													label="Banco"
													name="payment_bank_id"
													onChange={ (e: any) => this.change(e) }
													value={ this.state.form.payment_bank_id }
													options={ this.state.banks.map((i: any) => {
														return {
															value: i.id,
															label: i.name
														}
													}) } />
											</div>
											<div className="col-md-6">
												<DatePicker
													label="Fecha"
													maxDate={ moment().toDate() }
													onChange={ (text: string) => {
														this.change({
															target: {
																value: text,
																name: 'payment_date'
															}
														});
													} }
													value={ this.state.form.payment_date }
												/>
											</div>
											<div className="col-md-6">
												<Input
													type="number"
													color="white"
													value={ this.state.form.payment_phone }
													name="payment_phone" 
													label="Teléfono"
													maxLength={ 11 }
													onChange={ this.change } />
											</div>

											<div className="col-12">
												<PaperClip
													value={this.state.form.payment_photo}
													successText={`Foto Adjuntada`}
													pendingText={`Subir comprobante (Opcional)`}
													onChange={(e: any) => {
														this.setState({
															form: {
																...this.state.form,
																payment_photo: e.target
															}
														})
													}} />
											</div>

											<div className="col-12">
												<Input
													className="reference"
													type="number"
													color="white"
													value={ this.state.form.payment_reference }
													name="payment_reference" 
													maxLength={ 4 }
													placeholder="Últimos 4 dígitos de referencia"
													onChange={ this.change } />
											</div>
										</div>
									</React.Fragment>
								)
							}

							{
								// @ts-ignore
								this.state.form.payment_method_id == Constants.PAYMENT_METHODS.TRANSFER && (
									<React.Fragment>			
										<div className="row row-payments">
											<div className="col-md-8">
												<h6>Datos para el pago</h6>
												<p>{ transfer?.account_name }</p>
												<p>{ transfer?.bank?.name } - { transfer?.bank?.code }</p>
												<p>{ transfer?.account_number }</p>
												<p>{ transfer?.document_type?.name + transfer?.document }</p>
											</div>
											<div className="col-md-4 text-right">
												<h6>Total a pagar</h6>
												<p className="total">{ Globals.formatMiles(this.state.item?.price) }</p>
												<p className="total-bs">{ Globals.formatMiles(this.state.item?.price,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,this.props.conversion?.amount || 0) }</p>
											</div>
										</div>						
										<div className="row">
											<div className="col-12">
												<h5>Confirmar pago</h5>
											</div>
											<div className="col-md-6">
												<Select
													label="Banco"
													name="payment_bank_id"
													onChange={ (e: any) => this.change(e) }
													value={ this.state.form.payment_bank_id }
													options={ this.state.banks.map((i: any) => {
														return {
															value: i.id,
															label: i.name
														}
													}) } />
											</div>
											<div className="col-md-6">
												<DatePicker
													label="Fecha"
													maxDate={ moment().toDate() }
													onChange={ (text: string) => {
														this.change({
															target: {
																value: text,
																name: 'payment_date'
															}
														});
													} }
													value={ this.state.form.payment_date }
												/>
											</div>
											<div className="col-12">
												<PaperClip
													value={ this.state.form.payment_photo }
													successText={ `Foto Adjuntada` }
													pendingText={ `Imagen del pago` }
													onChange={ (e: any) => {
														this.setState({
															form: {
																...this.state.form,
																payment_photo: e.target
															}
														})
													} } />
											</div>
											<div className="col-12">
												<Input
													className="reference"
													type="number"
													color="white"
													value={ this.state.form.payment_reference }
													name="payment_reference" 
													maxLength={ 4 }
													placeholder="Últimos 4 dígitos de referencia"
													onChange={ this.change } />
											</div>
										</div>
									</React.Fragment>
								)
							}

							{
								// @ts-ignore
								this.state.form.payment_method_id == Constants.PAYMENT_METHODS.ZELLE && (
									<React.Fragment>
										<div className="row row-payments">
											<div className="col-md-8">
												<h6>Datos para el pago</h6>
												<p>{ payment_zelle?.email }</p>
											</div>
											<div className="col-md-4 text-right">
												<h6>Total a pagar</h6>
												<p className="total">{ Globals.formatMiles(this.state.item?.price) }</p>
											</div>
										</div>
										<div className="row">
											<div className="col-12">
												<h5>Confirmar pago</h5>
											</div>
											<div className="col-md-6">
												<DatePicker
													label="Fecha de pago"
													maxDate={ moment().toDate() }
													onChange={ (text: string) => {
														this.change({
															target: {
																value: text,
																name: 'payment_date'
															}
														});
													} }
													value={ this.state.form.payment_date }
												/>
											</div>
											<div className="col-md-6">
												<Input
													color="white"
													label="Persona que realizó el pago"
													value={ this.state.form.payment_name }
													name="payment_name" 
													placeholder="Nombre"
													onChange={ this.change } />
											</div>
											<div className="col-12">
												<PaperClip
													value={ this.state.form.payment_photo }
													successText={ `Foto Adjuntada` }
													pendingText={ `Imagen del pago` }
													onChange={ (e: any) => {
														this.setState({
															form: {
																...this.state.form,
																payment_photo: e.target
															}
														})
													} } />
											</div>
										</div>
									</React.Fragment>
								)
							}

							{
								// @ts-ignore
								this.state.form.payment_method_id == Constants.PAYMENT_METHODS.CASH && (
									<React.Fragment>			
										<div className="row row-payments">
											{
												bank_account && (
													<div className="col-md-12" style={{ marginBottom: '20px' }}>
														<h6>Datos para el pago</h6>
														<p>{ bank_account?.number }</p>
														<p>{ bank_account?.bank?.name } - { bank_account?.bank?.code }</p>
													</div>
												)
											}
											<div className="col-md-6">
												<Select
													label="Cuenta bancaria"
													name="payment_bank_account_id"
													onChange={ (e: any) => this.change(e) }
													value={ this.state.form.payment_bank_account_id }
													options={ this.state.bank_accounts.map((i: any) => {
														return {
															value: i.id,
															label: i.number + ' - ' + i.bank?.name
														}
													}) } />
											</div>
											<div className="col-md-6 text-right">
												<h6>Total a pagar</h6>
												<p className="total">{ Globals.formatMiles(this.state.item?.price) }</p>
											</div>
											<div className="col-md-12">
												<DatePicker
													label="Fecha"
													maxDate={ moment().toDate() }
													onChange={ (text: string) => {
														this.change({
															target: {
																value: text,
																name: 'payment_date'
															}
														});
													} }
													value={ this.state.form.payment_date }
												/>
											</div>
											<div className="col-12">
												<Input
													className="reference"
													type="number"
													color="white"
													value={ this.state.form.payment_reference }
													name="payment_reference" 
													placeholder="Número de confirmación"
													onChange={ this.change } />
											</div>
										</div>
									</React.Fragment>
								)
							}

							{
								// @ts-ignore
								this.state.form.payment_method_id == Constants.PAYMENT_METHODS.CASH2 && (
									<div className="row">
										<div className="col-12">
											<h5>Confirmar pago</h5>
										</div>
										<div className="col-12">
											<PaperClip
												value={ this.state.form.payment_photo }
												successText={ `Foto Adjuntada` }
												pendingText={ `Imagen de los billetes` }
												onChange={ (e: any) => {
													this.setState({
														form: {
															...this.state.form,
															payment_photo: e.target
														}
													})
												} } />
										</div>
									</div>
								)
							}
						</div>
					)
				}
				
				{
					!this.state.visible_edit && this.state.item?.payment_method_id != Constants.PAYMENT_METHODS.CORPORATE && (
						<React.Fragment>
							<Textarea
								disabled={ !payment_pending }
								rows={ 2 }
								placeholder="Observaciones (Opcional)"
								name="observations"
								onChange={ this.change }
			                    value={ this.state.form.observations } />

			                {
			                	payment_pending && (
									<div className="row">
										<div className="col-md-6">
											<button className="btn btn-green" onClick={ () => this.accept() }>
												Aceptar
											</button>	
										</div>
										<div className="col-md-6">
											<button className="btn btn-red" onClick={ () => this.reject() }>
												Rechazar
											</button>
										</div>
									</div>
			                	)
			                }
		                </React.Fragment>
					)
				}

				{
					this.state.visible_edit && (
						<React.Fragment>
							<div className="text-center">
								<button className="btn btn-green" onClick={ () => this.submitPayment() }>
									Guardar
								</button>	
							</div>
						</React.Fragment>
					)
				}
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		conversion: state.conversion
	}
})(ModalChangeStatusPayment);